import { isTypeEmbedSectionRaw } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulEmbedSectionRaw = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeEmbedSectionRaw(entry)) {
    return null;
  }

  return <div>ContentfulEmbedSectionRaw</div>;
};

export default ContentfulEmbedSectionRaw;
